import "./CardGrupoFamiliarPending.css";
import IconVinculo from "../../../../assets/images/generico/GrupoFamiliarIcon";
import { wsPutRechazarVinculo, wsPutVinculo } from "../../../../context/Actions/grupoFamiliar/grupoFamiliar";
import { useContext } from "react";
import { PortalContext } from "../../../../context/Provider";
import { showModal } from "../../../../context/Actions/modal/modal";
import camelize from "../../../../../global/utils/camelize";
import { IonSpinner } from "@ionic/react";
import TildeOkAbonado from "../../../../assets/images/generico/TildeOkAbonado";
import WarningIcon from "../../../../assets/images/generico/WarningIcon";


const  CardGrupoFamiliarPending = ({vinculo,idpaciente2_desc,id, idpaciente2, derecho_editarPerfil, derecho_verResultados, derecho_manejoTurnos,}) => {

    const {grupoFamiliarDispatch, modalDispatch, grupoFamiliarState } = useContext(PortalContext);

    const onClickRechazo = () => {
        wsPutVinculo({
            idParentescoProcesa: 3,
        }, id)(grupoFamiliarDispatch)
    };

    const onClickAceptar = () => {
        wsPutVinculo({
            idParentescoProcesa: 1,
        },id )(grupoFamiliarDispatch)
    };


    const handleClick = () => {
        showModal('Perfil/ModalGrupoFamiliar/ModalGrupoFamiliar',
        {nombre: camelize(idpaciente2_desc), idpaciente1: idpaciente2, type: "PUT", id},
        [],
        "centro", true)(modalDispatch);
      }


    const solictudPending =  grupoFamiliarState.grupoFamiliar.putFamiliar.loading;
    return (
        <div className="ptur-grupoFamiliarPending-container">
            <div className="ptur-grupoFamiliarPending-top bgcG-danger">
              <div><IconVinculo/></div>
              <span className="rb18m">Solicitud de vinculación</span>
            </div>
            <div className="ptur-grupoFamiliarPending-body">
                <span className="rb16xl">Aceptar {idpaciente2_desc} <span className="rb16m">a tu grupo familiar?</span> </span>
            </div>
            <div className="separador-div"></div>
            <div className="ptur-grupoFamiliarPending-body-centroProlijo">
            <div className="ptur-grupoFamiliar-derechos-icon">
              <div className="ptur-grupoFamiliar-iconWarning-pending">
                <WarningIcon />
              </div>
              <div className="ptur-grupoFamiliar-InfoDerechos-vinculo rb14m">
                 Su familiar tendrá los siguientes derechos en el portal sobre usted.
              </div>
            </div>
            <div className="ptur-grupoFamiliar-derechos">
              <div className="ptur-grupoFamiliar-derechosTilde">
                {derecho_editarPerfil === true ? (
                  <div className="ptur-grupoFamiliar-tilde c-broccoli rb14m">
                    <TildeOkAbonado />
                    Editar Perfil
                  </div>
                ) : (
                  ""
                )}
                {derecho_manejoTurnos === true ? (
                  <div className="ptur-grupoFamiliar-tilde c-broccoli rb14m">
                    <TildeOkAbonado />
                    Manejo Turnos
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="ptur-grupoFamiliar-derechosTilde">
                {derecho_verResultados === true ? (
                  <div className="ptur-grupoFamiliar-tilde c-broccoli rb14m">
                    <TildeOkAbonado />
                    Ver Resultados
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            </div>
            <div className="ptur-grupoFamiliarPending-footer">
                {
                    solictudPending ? 
                    <button className="ptur-grupoFamiliar-buttonRechazar rb18m" >
                        <span className={"c-white"}>
                            <IonSpinner name="lines"/>
                        </span>
                    </button>: 
                   <button className="ptur-grupoFamiliar-buttonRechazar rb18m" onClick={onClickRechazo}>Rechazar</button>
                }
                
                {
                    solictudPending ?
                    <button className="ptur-grupoFamiliar-buttonAceptar rb18m" >
                        <span className={"c-white"}>
                            <IonSpinner name="lines"/>
                        </span>
                    </button>
                    :
                    <button className="ptur-grupoFamiliar-buttonAceptar rb18m" onClick={onClickAceptar}>Aceptar</button>
                }
            </div>
            
        </div>
    )
}


export default CardGrupoFamiliarPending;